/** The empty state line under "No games today". It always reads as a whole
 *  sentence: never a blank league, never a dangling "in ." or "on ." (ISSUE-976 R4). */
export type typeEmptyLineInput = {
  /** The league's short name from the catalog, for example "NFL". "" when
   *  the catalog has not answered or failed. */
  shortName: string;
  /** "week" when the league is shown by week, "day" when by day. */
  mode: "week" | "day";
  /** The selection's short name, "Week 3" or "Wednesday, Sept 9". "" when
   *  nothing is selected. */
  selectionLabel: string;
};

export function buildEmptyLine(input: typeEmptyLineInput): string {
  const leaguePhrase =
    input.shortName.trim() === "" ? "this league" : `the ${input.shortName}`;
  if (input.selectionLabel.trim() === "") {
    return `Nothing scheduled in ${leaguePhrase} yet.`;
  }
  if (input.mode === "week") {
    return `Nothing scheduled in ${leaguePhrase} in ${input.selectionLabel}.`;
  }
  return `Nothing scheduled in ${leaguePhrase} on ${input.selectionLabel}.`;
}
